import tw from 'twin.macro'
import { useContext } from 'react'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { SubcontractorRequestsTableContext } from '../SubcontractorRequestsTable.context'
import { SubcontractorRequestsMCSelect } from './SubcontractorRequestsMCSelect'
import { SubcontractorRequestsBatchActionButton } from './SubcontractorRequestsBatchActionButton'

export const SubcontractorRequestsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(SubcontractorRequestsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-2`}>
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          className="w-[284px]"
        />
        <SubcontractorRequestsMCSelect />
      </div>
      <SubcontractorRequestsBatchActionButton />
    </div>
  )
}
